import $ from 'jquery';
import "jquery-validation";
import { Carousel } from 'bootstrap';


interface ValidationConfig {
    [key: string]: {
        required: boolean;
        pattern?: RegExp;
    };
}

interface MessageConfig {
    [key: string]: {
        required: string;
        pattern?: string;
    };
}



export interface TwoFactorInputManagerOptions {
    containerSelector: string | JQuery<HTMLInputElement[]>;
    verifyFunctionHandler: (code: string) => void;
}

export class TwoFactorInputManager {
    private _options: TwoFactorInputManagerOptions;
    private _elements: HTMLInputElement[] = [];
    private _form: HTMLFormElement;
    private _loginCarousel: Carousel;

    constructor(options?: TwoFactorInputManagerOptions) {

        const carousel = false;

        this._options = options = options ?? {
            containerSelector: ".pinCodeContainer",
            verifyFunctionHandler: function (code) {
                $('input[type=hidden][name=Token]').val(code);
                $('input[type=hidden][name=Token]').closest('form').submit();
            }
        };
        

        this.initPinCode(options.containerSelector, options.verifyFunctionHandler);
        //this.initializeOtpValidation();

        if (carousel) {
            const myCarouselElement = document.querySelector('#loginCarousel')

            this._loginCarousel = new Carousel(myCarouselElement, {
                interval: 0,
                touch: false,
                ride: false,
            })
        }
    }

    public next() {
        this._loginCarousel.next();
    }

    public clearInput() {
        var inputs = document.querySelector(this._options.containerSelector as string).querySelectorAll('input[type="number"]');
        inputs.forEach((input: HTMLInputElement) => {
            input.value = '';
        });
        (inputs[0] as HTMLInputElement).focus();
    }

    private initPinCode(containerSelector, verifyFunctionHandler) {


        let ins = document.querySelector(containerSelector).querySelectorAll('input[type="number"]'),
            in1 = ins[0],
            splitNumber = function (e) {
                let data = e.data || e.target.value; // Chrome doesn't get the e.data, it's always empty, fallback to value then.
                if (!data) return; // Shouldn't happen, just in case.
                if (data.length === 1) return; // Here is a normal behavior, not a paste action.
                else {
                    if (data.length >= 6) {
                        //Clear before pasting (to avoid auto postback before all digit replaced)
                        ins.forEach(input => input.value = '');
                    }

                    popuNext(e.target, data);
                }
            },
            popuNext = function (el, data) {

                if (el.nodeName !== 'INPUT') {
                    // probleme avec jquery validation qui ajout les span !
                    popuNext(el.next('INPUT'), data);
                } else {
                    el.focus();
                    el.value = data[0]; // Apply first item to first input
                    data = data.substring(1); // remove the first char.
                    if (el.nextElementSibling && data.length) {
                        // Do the same with the next element and next data
                        popuNext(el.next('INPUT'), data);
                    }
                }
            };

        //set focus on first input
        in1.focus();

        ins.forEach(function (input) {
            input.addEventListener('keypress', (k, e) => {
                if (k.keyCode == 13 || k.target.value.length == 5) {
                    setTimeout(verify, 0);
                }
            });
            input.addEventListener('input', (k, e) => {
                // If the target is populated to quickly, value length can be > 1
                if (k.target.value.length > 1) {
                    splitNumber(k);
                }

                var submitCode = true;
                ins.forEach(i => {
                    if (i.value.length == 0) submitCode = false;
                    return;
                });

                //Submit code if all inputs are filled
                if (submitCode) {
                    setTimeout(verify, 1);
                }
            });

            /**
             * Control on keyup to catch what the user intent to do.
             * I could have check for numeric key only here, but I didn't.
             */
            input.addEventListener('keyup', function (e) {
                // Break if Shift, Tab, CMD, Option, Control.
                if (e.keyCode === 16 || e.keyCode == 9 || e.keyCode == 224 || e.keyCode == 18 || e.keyCode == 17) {
                    return;
                }

                // On Backspace or left arrow, go to the previous field.
                if ((e.keyCode === 8 || e.keyCode === 37) && this.previousElementSibling && this.previousElementSibling.tagName === "INPUT") {
                    this.previous('INPUT').select();
                }
                // If not backspace or del go to next field.
                else if (e.keyCode !== 8 && e.keyCode !== 46 && this.nextElementSibling) {
                    this.next('INPUT').select();
                }
            });

            /**
             * Better control on Focus
             * - don't allow focus on other field if the first one is empty
             * - don't allow focus on field if the previous one if empty (debatable)
             * - get the focus on the first empty field
             */
            input.addEventListener('focus', function (e) {
                // If the focus element is the first one, do nothing
                if (this === in1 && in1.value == '') return;

                // If value of input 1 is empty, focus it.
                if (in1.value == '') {
                    in1.focus();
                }

                // If value of a previous input is empty, focus it.
                // To remove if you don't wanna force user respecting the fields order.
                else if (this.previousElementSibling.value == '') {
                    this.previous('INPUT').focus();
                }
                else {
                    this.select();
                }
            });
        });

        /**
         * Handle copy/paste of a big number.
         * It catches the value pasted on the first field and spread it into the inputs.
         */
        in1.addEventListener('input', splitNumber);
        this._elements = ins;
        this._form = in1.closest("form") as HTMLFormElement;

        function verify() {

            let code = $.map(ins, i => i.value).join('');
            //(in1.closest("form") as HTMLFormElement).submit();
            verifyFunctionHandler(code);
        };

    }


    private initializeOtpValidation(formSelector: string = '#otp-form') {
        // G�n�rer dynamiquement les r�gles et messages pour otc[0] � otc[5]
        const rules: ValidationConfig = {};
        const messages: MessageConfig = {};

        for (let i = 0; i < 6; i++) {
            const fieldName = `otc[${i}]`;
            rules[fieldName] = {
                required: true,
                pattern: /^[0-9]$/,
            };
            messages[fieldName] = {
                required: `Chiffre ${i + 1} requis`,
                pattern: `Chiffre ${i + 1} doit �tre 0-9`,
            };
        }

        // Configurer jQuery Validation
        //$(formSelector).validate({
        //    rules,
        //    messages,
        //    errorPlacement: function (error: JQuery, element: JQuery) {
        //        const index = element.attr('name')?.match(/\d+/)?.[0] || '0';
        //        const errorSpan = $(`#error-otc-${index}`);
        //        errorSpan.text(error.text());
        //    },
        //    highlight: function (element: HTMLElement) {
        //        $(element).addClass('is-invalid').removeClass('is-valid');
        //    },
        //    unhighlight: function (element: HTMLElement) {
        //        $(element).removeClass('is-invalid').addClass('is-valid');
        //        const index = $(element).attr('name')?.match(/\d+/)?.[0] || '0';
        //        $(`#error-otc-${index}`).text('');
        //    },
        //});

        // Auto-focus sur le champ suivant apr�s saisie
        //$("input[name^='otc']").on('input', function () {
        //    const input = this as HTMLInputElement;
        //    input.value = input.value.replace(/[^0-9]/g, '');
        //    if (input.value.length === 1) {
        //        const index = parseInt(input.id.split('-')[1]);
        //        if (index < 5) {
        //            $(`#otc-${index + 1}`).focus();
        //        }
        //    }
        //});
    }


    public get value(): string {
        return $.map(this._elements, i => i.value).join('');
    }

}

// Attache TwoFactorInputManager 
window.TwoFactorInputManager = TwoFactorInputManager;

